/* eslint-disable @typescript-eslint/naming-convention */
import { inject, injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';
import { BaseRequestModel } from '../models/base-request.model';

@injectable()
export class JobsApi {
    constructor(@inject(HttpClient) private readonly httpClient: HttpClient) {}

    getJobs = async (data: GetJobsRequestModel, cancellationToken?: CancelToken) => {
        return this.httpClient.post<JobsResponse, GetJobsRequestModel>('/jobs', data, {
            cancelToken: cancellationToken,
        });
    };

    addJobNote = async (
        jobId: number | string,
        note: AddJobNoteRequest,
        cancellationToken?: CancelToken
    ) => {
        return this.httpClient.post<void, AddJobNoteRequest>(`/api/v1/jobs/${jobId}/notes`, note, {
            cancelToken: cancellationToken,
        });
    };
}

export interface JobsResponse {
    jobs: JobApiModel[];
}

interface GetJobsRequestModel extends BaseRequestModel {
    job_id: number;
}

export interface JobApiModel {
    job_id: number;
    job_name: string;
    job_number: string;
    location_id: number;
    job_description: string;
    job_status: string; // should convert to enum
    job_start_date: Date;
    job_location: string;
    job_type: string;
    customer_name: string;
}

export interface AddJobNoteRequest {
    text: string;
}
